export function formatErrors (errors) {
  const errorString = errors.map((obj) => {
    return '<li>' + obj + '</li>'
  }).join('')

  return `<ul>${errorString}</ul>`
}



// WEBPACK FOOTER //
// ./src/utils/errors-alert.js